<script>
/*import PublicInstitutionsByStatusWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-status/public-institutions-by-status-widget.vue";
import PublicInstitutionsByRegionWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-region/public-institutions-by-region-widget.vue";
import BaselineVsImprovedDimensionsWidget
  from "@/modules/dashboard/components/summary-information/components/baseline-vs-improved-by-dimensions-widget.vue";
import PublicInstitutionsByTerritorialLevelWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-territorial-level-widget.vue";
import PublicInstitutionsBySectorWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-sector-widget.vue";
import EmployeesBySexWidget
  from "@/modules/dashboard/components/summary-information/components/employees-by-sex/employees-by-sex-widget.vue";

import PublicInstitutionsProvidingDirectServicesWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-providing-direct-services-widget.vue";
import WidgetContainer from "@/modules/dashboard/components/summary-information/components/widget-container.vue";
import PublicInstitutionsByRegionMapWidget
  from "@/modules/dashboard/components/summary-information/components/public-institutions-by-region/public-institutions-by-region-map-widget.vue";
import Survey from "@/modules/dashboard/components/summary-information/components/survey/survey-widget.vue";

import {onMounted, ref, watch} from "vue";
import {
  InstitutionsByStatusStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-status.store";
import {
  InstitutionsByRegionStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-region.store";
import {
  BaselineVsImprovedByDimensionsStore
} from "@/modules/dashboard/components/summary-information/stores/baseline-vs-improved-by-dimensions.store";
import {
  InstitutionsByTerritorialLevelStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-territorial-level.store";
import {
  InstitutionsBySectorStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-sector.store";
import {EmployeesBySexStore} from "@/modules/dashboard/components/summary-information/stores/employees-by-sex.store";
import {SurveyEnum} from "@/modules/dashboard/components/summary-information/model/survey.enum";
import {SurveyStore} from "@/modules/dashboard/components/summary-information/stores/survey.store";
import {
  InstitutionsDirectServicesStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-direct-services.store";
import {
  InstitutionsByCountryStore
} from "@/modules/dashboard/components/summary-information/stores/institutions-by-country.store";
import {
  DashboardSelectedFiltersStore
} from "@/modules/dashboard/components/filters/stores/dashboard-selected-filters.store";
import {i18n} from "@/shared/locale/locale";
import {prepareParams} from "@/modules/dashboard/components/utils";
import {UserStore} from "@/shared/stores/user.store";
import {SubHeaderStore, SubHeaderType} from "@/shared/components/sub-header/stores/sub-header.store";
import {apiCall} from "@/shared/utils/api-call";
import {VueSpinner} from "vue3-spinners";
import {reportUrl} from "@/shared/utils/url-generator";
import router from "@/router";

var showCacheGeneration = ref(false);
var missingCache = ref(+(window as any).missingUsersCache);
var currentMissing = ref(+(window as any).missingUsersCache);
var showDashboardAsAdmin = (window as any).showDashboardAsAdmin
var isPublicInstitution = (window as any).isPublicInstitution
if(isPublicInstitution){
  router.push({ name: 'baseline-vs-improved'})
}else {
  var dashboardSelectedFiltersStore = DashboardSelectedFiltersStore();

  var institutionsByStatusStore = InstitutionsByStatusStore();
  var institutionsByRegionStore = InstitutionsByRegionStore();
  var institutionsByCountryStore = InstitutionsByCountryStore();
  var baselineVsImprovedByDimensionsStore = BaselineVsImprovedByDimensionsStore();
  var institutionsByTerritorialLevelStore = InstitutionsByTerritorialLevelStore();
  var institutionsBySectorStore = InstitutionsBySectorStore();
  var employeesBySexStore = EmployeesBySexStore();
  var surveyStore = SurveyStore();
  var institutionsDirectServicesStore = InstitutionsDirectServicesStore();

  var store = UserStore();

  var refresh = () => {
    institutionsByStatusStore.fetchInstitutionsByStatus(prepareParams());
    institutionsByRegionStore.fetchInstitutionsByRegion(prepareParams());
    institutionsByCountryStore.fetchInstitutionsByCountry(prepareParams());
    baselineVsImprovedByDimensionsStore.fetchBaselineVsImprovedByDimension(
        prepareParams(),
    );
    institutionsByTerritorialLevelStore.fetchInstitutionsByTerritorialLevel(
        prepareParams(),
    );
    institutionsBySectorStore.fetchInstitutionsBySector(prepareParams());
    employeesBySexStore.fetchEmployeesBySex(prepareParams());
    surveyStore.fetchInstitutionsSurveys(prepareParams());
    institutionsDirectServicesStore.fetchInstitutionsDirectService(
        prepareParams(),
    );
    dashboardSelectedFiltersStore.fetchPiCount(prepareParams());
  };

  watch(
      () => [
        dashboardSelectedFiltersStore.year,
        dashboardSelectedFiltersStore.previousYears,
        dashboardSelectedFiltersStore.status,
        dashboardSelectedFiltersStore.territorialLevel,
        dashboardSelectedFiltersStore.sector,
        dashboardSelectedFiltersStore.region,
        dashboardSelectedFiltersStore.country,
        i18n.global.locale,
      ],
      () => {
        refresh();
      },
  );

  var subheaderStore = SubHeaderStore();


  onMounted(async () => {
    if(showDashboardAsAdmin) {
      dashboardSelectedFiltersStore.setShowNonAccessibleAreas(true)
    }
    store.setTitle('label_title_summary_information')
    subheaderStore.setSubHeader(SubHeaderType.dashboard)


    await apiCall<number>("wp-json/v2/dashboard/generate-survey-combinations/", {});

    while (currentMissing.value != 0) {
      showCacheGeneration.value = true;
      try {
        currentMissing.value = await apiCall<number>("wp-json/v2/dashboard/generate-single-cache/", {});
      } catch (e) {
      }
    }

    showCacheGeneration.value = false;
    refresh();

  });
}*/
import {defineComponent} from "vue";
import WidgetContainer from "@/components/modules/new-dashboard/components/WidgetContainer.vue";
import OrganizationsByStatus from "@/components/modules/new-dashboard/components/OrganizationsByStatus.vue";
import OrganizationsByRegion
  from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-map-widget.vue";
import OrganizationsByRegionWidget
  from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-widget.vue";
import OrganizationsByRegionMapWidget
  from "@/components/modules/new-dashboard/components/organizations-by-region/organizations-by-region-map-widget.vue";
import OrganizationsByTypeWidget from "@/components/modules/new-dashboard/components/organizations-by-type-widget.vue";
import EmployeesBySexWidget
  from "@/components/modules/new-dashboard/components/employees-by-sex/employees-by-sex-widget.vue";
import EmployeesByOrganizationSize
  from "@/components/modules/new-dashboard/components/employees-by-organization-size.vue";
import OrganizationsByEconomyActivity
  from "@/components/modules/new-dashboard/components/organizations-by-economic-activity/organizations-by-economic-activity.vue";
import SurveyWidget from "@/components/modules/new-dashboard/components/survey/survey-widget.vue";
import {mapGetters} from "vuex";
import Filters from "@/components/template/_template-filters.vue";
import DashboardFilters from "@/components/modules/new-dashboard/components/dashboard-filters.vue";
import TrackerOrganizationsByStatus
  from "@/components/modules/tracker-dashboard/components/tracker-OrganizationsByStatus.vue";
import TrackerEmployeesBySexWidget
  from "@/components/modules/tracker-dashboard/components/tracker-employees-by-sex/tracker-employees-by-sex-widget.vue";
import TrackerOrganizationsByRegionWidget
  from "@/components/modules/tracker-dashboard/components/tracker-organizations-by-region/tracker-organizations-by-region-widget.vue";
import TrackerOrganizationsByRegionMapWidget
  from "@/components/modules/tracker-dashboard/components/tracker-organizations-by-region/tracker-organizations-by-region-map-widget.vue";
import TrackerOrganizationsBySector
  from "@/components/modules/tracker-dashboard/components/tracker-organizations-by-sector.vue";
import TrackerMultinationalOrganizationsWidget
  from "@/components/modules/tracker-dashboard/components/tracker-multinational-organizations-widget.vue";
import TrackerOrganizationsByEconomyActivity
  from "@/components/modules/tracker-dashboard/components/tracker-organizations-by-economic-activity/tracker-organizations-by-economic-activity.vue";
import TrackerDashboardFilters from "@/components/modules/tracker-dashboard/components/tracker-dashboard-filters.vue";
import DashboardSelector from "@/components/modules/new-dashboard/dashboard-selector.vue";
import TrackerEmployeesByOrganizationSize
  from "@/components/modules/tracker-dashboard/components/tracker-employees-by-organization-size.vue";
import {debounce} from "lodash";

export default defineComponent({
  components: {
    TrackerEmployeesByOrganizationSize,
    DashboardSelector,
    TrackerDashboardFilters,
    TrackerOrganizationsByEconomyActivity,
    TrackerMultinationalOrganizationsWidget,
    TrackerOrganizationsBySector,
    TrackerOrganizationsByRegionMapWidget,
    TrackerOrganizationsByRegionWidget,
    TrackerEmployeesBySexWidget,
    TrackerOrganizationsByStatus,
    DashboardFilters,
    Filters,
    SurveyWidget,
    OrganizationsByEconomyActivity,
    EmployeesByOrganizationSize,
    EmployeesBySexWidget,
    OrganizationsByTypeWidget,
    OrganizationsByRegionMapWidget,
    OrganizationsByRegionWidget, OrganizationsByRegion, OrganizationsByStatus, WidgetContainer
  },
  mounted() {
    var containerElem = this.$refs.dashboardContainer;

    if (containerElem instanceof Element) {
      this.resizeObserver = new ResizeObserver(
        debounce(() => {
          if (containerElem.offsetWidth !== this.currentWidth) {
            this.currentWidth = containerElem.offsetWidth;
            this.randomKey = Math.random().toString(36);
          }
        }, 100)
      );

      this.resizeObserver.observe(containerElem);
    }
  },
  data: function () {
    return {
      randomKey: 1,
      resizeObserver: null,
    }
  },
  beforeDestroy() {
    this.resizeObserver?.disconnect();
  },
  computed: {

    ...mapGetters([
      'getTrackerTotalCountries',
      'getTotalOrganizations',
      'getTrackerImpactedWorkers',
      'getTotalTrackerEmployeesByOrganizationSize',
      'getTrackerTotalOrganizationsByRegion',
      'getTrackerTotalOrganizationsBySector',
      'getTrackerTotalOrganizationsByEconomicActivity']
    )
  }
})
</script>

<template>
  <div style="position: relative" ref="dashboardContainer">
    <div class="summary-information" id="download-screen">
      <widget-container
        title="label_dashboard_organizations_by_status_title"
        :grid-column-start="1"
        :grid-column-end="5"
        :grid-row-start="1"
        :grid-row-end="2"
      >
        <tracker-organizations-by-status></tracker-organizations-by-status>
      </widget-container>

      <widget-container title="label_dashboard_impacted_workers_title" widget-padding="10px 15px 0px 15px"
                        :count="getTrackerImpactedWorkers.data?.total"
                        :grid-column-start="5"
                        :grid-column-end="9"
                        :grid-row-start="1"
                        :grid-row-end="2"
      >
        <tracker-employees-by-sex-widget></tracker-employees-by-sex-widget>
      </widget-container>

      <widget-container
        title="label_dashboard_employees_by_organization_size_title"
        :count="getTotalTrackerEmployeesByOrganizationSize"
        :grid-column-start="9"
        :grid-column-end="13"
        :grid-row-start="1"
        :grid-row-end="2"
      >
        <tracker-employees-by-organization-size :key="randomKey"></tracker-employees-by-organization-size>
      </widget-container>

      <widget-container
        :countries-count="getTrackerTotalCountries"
        :count="getTrackerTotalOrganizationsByRegion"
        title="label_dashboard_organizations_by_region_title"
        :grid-column-start="1"
        :grid-column-end="9"
        :grid-row-start="2"
        :grid-row-end="3"
        widget-padding="0px"
        widget-width="436px"
        inner-padding="10px 15px"
      >
        <TrackerOrganizationsByRegionWidget :key="randomKey"></TrackerOrganizationsByRegionWidget>
        <template v-slot:right>
          <tracker-organizations-by-region-map-widget :key="randomKey"></tracker-organizations-by-region-map-widget>
        </template>
      </widget-container>

      <widget-container
        title="label_dashboard_employees_by_organization_sector_title"
        :count="getTrackerTotalOrganizationsBySector"
        :grid-column-start="9"
        :grid-column-end="13"
        :grid-row-start="2"
        :grid-row-end="3"
      >
        <tracker-organizations-by-sector :key="randomKey"></tracker-organizations-by-sector>
      </widget-container>

      <widget-container title="label_dashboard_multinational_organizations_title"
                        :grid-column-start="1"
                        :grid-column-end="4"
                        :grid-row-start="3"
                        :grid-row-end="4"
      >
        <tracker-multinational-organizations-widget :key="randomKey"></tracker-multinational-organizations-widget>
      </widget-container>

      <widget-container
        title="label_dashboard_organizations_by_economic_activity_title"
        :grid-column-start="4"
        :grid-column-end="13"
        :grid-row-start="3"
        :grid-row-end="4"
        :count="getTrackerTotalOrganizationsByEconomicActivity"
      >
        <tracker-organizations-by-economy-activity :key="randomKey"></tracker-organizations-by-economy-activity>
      </widget-container>
    </div>
  </div>
</template>
<style scoped>
.summary-information {
  padding: 30px;
  display: grid;
  column-gap: 20px;
  row-gap: 20px;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  background-color: #f2f6f8;
  overflow: scroll;
  min-width: 1200px;
}

.second-grid {
  display: grid;
  column-gap: 20px;
  row-gap: 20px;
  grid-template-columns: 1fr;
}

.third-grid {
  display: grid;
  column-gap: 20px;
  row-gap: 20px;
  grid-template-columns: 1fr 1fr;
  grid-column-start: 2;
  grid-column-end: 4;
}
</style>
